import { axios } from "lib/axios"

export const unsubscribeByToken = async (token) => {
  return await axios.get(`/website/unsubscribe/${token}`);
}
